import { clamp } from '@/utilities/numbers.ts'

const units = [
	'byte',
	'kilobyte',
	'megabyte',
	'gigabyte',
	'terabyte',
	'petabyte',
]

/**
 * Format file size to a human-readable format
 * @param size File size in bytes
 */
export function formatFileSize(locale: Intl.LocalesArgument, size: number) {
	const index = clamp(
		Math.floor(Math.log(size) / Math.log(1024)),
		0,
		units.length - 1,
	)

	const value = size / Math.pow(1024, index)

	const formatter = new Intl.NumberFormat(locale, {
		style: 'unit',
		unit: units[index],
		maximumFractionDigits: 1,
	})

	return formatter.format(value)
}
